var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pf-c-toggle-group__item"},[_c('button',{class:[
      'pf-c-toggle-group__button',
      _vm.selected ? 'pf-m-selected' : '',
      _vm.disabled ? 'pf-m-disabled' : '',
      ],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{attrs:{"icon":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }